import { render, staticRenderFns } from "./EnfoldUC.vue?vue&type=template&id=168707f0&scoped=true"
var script = {}
import style0 from "./EnfoldUC.vue?vue&type=style&index=0&id=168707f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168707f0",
  null
  
)

export default component.exports